import styled from 'styled-components';

const StyledMenuContainer = styled.div`
	position: relative;
	width: 100%;
	height: 40px;
	display: flex;
	gap: 20px;
	user-select: none;

	&::after {
		content: '';
		box-sizing: content-box !important;
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 1px;
		opacity: 0.1;
		background-color: white;
	}
`;

export { StyledMenuContainer };
